import React from "react";
import { Box, Container } from "@mui/material";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Services from "./sections/Services";
import Projects from "./sections/Projects";
import Testimonials from "./sections/Testimonials";
import Contact from "./sections/Contact";

const HomePage = () => {
  return (
    <Box>
      <Hero />
      <Container maxWidth="lg">
        <Box mb={10}>
          <About />
        </Box>
        <Box mb={10}>
          <Services />
        </Box>
        <Box mb={10}>
          <Projects />
        </Box>
        <Box mb={10}>
          <Testimonials />
        </Box>
        <Contact />
      </Container>
    </Box>
  );
};

export default HomePage;
